import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ExportarCsvService {
  PATH = new ConfigService().obtenerPath(); 

  

  constructor(
    private http      :Http,
    private toastr    : ToastrService,
  ) {}



    /**
   * Es el store que permite crear una nueva marca.
   * @param  csv  arreglo de datos a exportar trae cabecera y cintenido
   * @param  filename  nombre del archivo con el cual se va a descargar el cual se envia desde la vista 
   * @creó CAAA  06/06/2019
   */

  exportTableToCSV(csv1,filename) 
  {
    
    let csv = []
     for (var a = 0; a < csv1.length; a ++){
       csv.push(csv1[a].replace('Á','A').replace('É','E').replace('Í','I').replace('Ó','O').replace('Ú','U').replace('Gestión','Gestion')
                       .replace('Ñ','N').replace('á','a').replace('é','e').replace('í','i').replace('ó','o').replace('ò','o') 
                       .replace('ú','u').replace('ñ','n').replace('Ü','U').replace('ü','u'));
     }

    //fecha acual del sistema para agregar a los documentos de exportar
    var hoy = new Date();
    var dia = hoy.getDate(); 
    var mes = hoy.getMonth();
    var anio= hoy.getFullYear();
    var fecha_actual = (" "+anio+"/"+mes+"/"+dia);
    
      var rows = document.querySelectorAll("descargar table tr");
      
      for (var i = 0; i < rows.length; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");
          
          for (var j = 0; j < cols.length; j++) {
            row.push(cols[j].innerHTML);
          }
          csv.push(row.join(","));        
      }
      // Download CSV file
      this.downloadCSV(csv.join(""), filename + fecha_actual + ".csv");
   
  }
     
      /**
     * Permite descargar en formato Excel
     */

    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;

      // CSV file
      csvFile = new Blob([csv], {type: "text/csv;charset=utf-8"});

      // Download link
      downloadLink = document.createElement("a");

      // File name
      downloadLink.download = filename;

      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Hide download link
      downloadLink.style.display = "none";

      // Add the link to DOM
      document.body.appendChild(downloadLink);

      // Click download link
      downloadLink.click();
      this.toastr.success('Se descargo el archivo con exito', '', { timeOut: 3000 });
  }
  
  
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/exportar-csv/exportar-csv.service.ts